import { render, staticRenderFns } from "./analyticsDashboard.vue?vue&type=template&id=89bf7c2e&scoped=true&"
import script from "./analyticsDashboard.vue?vue&type=script&lang=js&"
export * from "./analyticsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./analyticsDashboard.vue?vue&type=style&index=0&id=89bf7c2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89bf7c2e",
  null
  
)

export default component.exports